export const REFRESHTOKEN = "/refresh-token";
export const GETCAPTCHA = "/captcha/generate";
export const PROXYLOGIN = '/pmfby-proxy-login';
export const LOGOUT = '/logout'
export const USERCONTENTPROGRESS = "/user-content-progress";
export const COURSELESSONPROGERSS = '/user-content-progress/course';
export const COURSEDETAIL = "/course-detail";
export const REFRESHCAPTCHA = '/captcha/refresh';
export const GETCOURSELIST = '/courses';
export const GETPMFBYROLES = '/pmfby-roles';
export const COURSEASSIGN = '/courseAssignment';
export const COURSEASSIGNBYROLE = '/courseAssignment/findByRole';
export const GROUPCOURSEASSIGMENT = '/group-course-assignment';
export const GROUPCOURSEASSIGN='/group-course-assignment';
export const USERCOURSEASSIGNMENT = `/user-course-assignment`;
export const GETQUIZ = '/quizzes';
export const ASSESSMENTSCORE = '/assessment-score';
export const COURSEPROGRESS = '/user-content-progress/course-progress-percent';
export const UPLOADVIDEO = '/videos/upload/';
export const VIDEOS='/videos';
export const ADDREFERENCEDOC = '/add-reference-doc';
export const UPLOADDOCUMENTS = '/documents/upload'
export const GETREFERENCEDOC = '/documents';
export const GETCERTIFICATES='/user-certificates/user';
export const GETMETRICS='/metrics/';
export const GETSTATE='/state-master';
export const GETDISTRICT='/districtMasterRoutes';
export const REGISTERUSER='/register-external-user';
export const USERCOURSEPROGRESSBASE = '/user-course-progress'
export const GETROLEWISEREPORT = USERCOURSEPROGRESSBASE+'/role-wise';
export const DOWNLOADUSERWISEREPORT = USERCOURSEPROGRESSBASE+'/user-wise';
export const GETROLEWISEREPORTSUMMARY = USERCOURSEPROGRESSBASE+'/summary/overall';
export const GETCOURSEWISEREPORT = USERCOURSEPROGRESSBASE+'/course-wise';
export const CREATEROLEGROUP = '/groups';
export const GETGROUPLIST = '/groups/names';
export const GETEXTERNALUSERSLIST = '/external-users';
export const SENDOTP = '/sms/send-otp';
export const VERIFYOTP = '/sms/verify-otp';
export const GROUPASSIGNEDCOURSEONROLE = '/group-assigned-courses/user-role';
export const HEARTBEAT = '/visitor/heartbeat';
export const LIVEUSERS = '/visitor/live';
export const REMOVEHEARTBEAT = '/visitor/remove';
export const COURSE_RATINGS = '/course-ratings';
export const RELEASE_LATEST = '/release/latest';
//{
//   "userId": "688077b0b7842cfa58cc323e",
//   "courseId": "6874dd9ae3a745fdf602d296",
//   "rating": 5,
//   "review": "<Course Review>."
// }
export const COURSE_RATING_COURSEWISE = COURSE_RATINGS + '/course';

//   'http://localhost:5000/lms/api/course-ratings/course/6874dd9ae3a745fdf602d296' \
export const COURSE_RATING_USERWISE= COURSE_RATINGS + '/user';
export const UPDATE_USER_DETAIL = '/user/insurance-company';
export const USER_PROFILE = '/user/profile';
export const CHANGE_PASSWORD = '/user/change-password';
export const MOBILE_SEND_OTP = '/user/mobile/send-otp';
export const MOBILE_VERIFY_OTP = '/user/mobile/verify-otp';
export const GETVISITERCOUNT = '/visitor/total';
export const GETEXTERNALUSER = '/external-users/export';
// (GET http verb) , API for exporting the external user
export const USERCOURSEPROGERSSCOURSEWISE = USERCOURSEPROGRESSBASE+'/course-wise?format=csv';
export const USERCOURSEWISESTATUSREPORT = USERCOURSEPROGRESSBASE+'/user-wise-course-wise';
export const ALLCOURSERATINGSUMMERY = '/user-course-progress/summary/overall-ratings';
export const PUBLIC_TOP_ENROLLED_COURSES = '/courses/top-enrolled';
export const TRAINING_EVENTS = '/training-events';
export const TRAINING_EVENTS_HOME = '/training-events/home';
